<script>
  import { onMount, onDestroy } from 'svelte';
  import ErrorLog from '../components/ErrorLog.svelte';
  import { getErrors, clearErrors as clearErrorsApi } from '../services/api';

  let errors = [];
  let loading = true;
  let interval;

  onMount(async () => {
    await refresh();
    interval = setInterval(refresh, 10000);
  });

  onDestroy(() => {
    if (interval) clearInterval(interval);
  });

  async function refresh() {
    try {
      const result = await getErrors();
      if (result.success) {
        errors = result.errors;
      }
    } catch (err) {
      console.error('Errors refresh error:', err);
    } finally {
      loading = false;
    }
  }

  async function handleClear() {
    try {
      const result = await clearErrorsApi();
      if (result.success) {
        errors = [];
      }
    } catch (err) {
      console.error('Clear errors error:', err);
    }
  }
</script>

<div class="logs-page">
  <h1 class="section-title">
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
      <polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/>
      <line x1="16" y1="17" x2="8" y2="17"/>
    </svg>
    Error Logs
  </h1>

  {#if loading}
    <div class="loading-state">
      <div class="spinner"></div>
      <span>Loading error logs...</span>
    </div>
  {:else}
    <ErrorLog {errors} on:clear={handleClear} />

    <div class="log-info">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/>
      </svg>
      Errors auto-expire after 24 hours • Maximum 50 entries stored
    </div>
  {/if}
</div>

<style>
  .logs-page {
    animation: fadeIn 0.3s ease;
  }

  .loading-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 14px;
    padding: 60px;
    color: var(--text-secondary);
    font-size: 14px;
  }

  .spinner {
    width: 28px;
    height: 28px;
    border: 2px solid var(--border-default);
    border-top-color: var(--neon-blue);
    border-radius: 50%;
    animation: spinSlow 0.8s linear infinite;
  }

  .log-info {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-top: 20px;
    font-size: 12px;
    color: var(--text-tertiary);
  }
</style>
